import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useAuth, useLoginRequiredModal } from '@/entities/user';

const ProtectedRoute = () => {
	const location = useLocation();
	const { isLoading, isLoggedIn } = useAuth();
	const openLoginRequiredModal = useLoginRequiredModal();

	useEffect(() => {
		if (isLoading || isLoggedIn) return;

		openLoginRequiredModal({
			redirectTo: '/onboarding',
			replace: true,
			state: { from: location },
		});
	}, [isLoading, isLoggedIn, location, openLoginRequiredModal]);

	if (isLoading) {
		return null;
	}

	return isLoggedIn ? <Outlet /> : null;
};

export default ProtectedRoute;
